// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".patsnap-ui-icon{vertical-align:middle}.patsnap-ui-icon svg{filter:progid:DXImageTransform.Microsoft.Blur(pixelradius=0)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
